import { DeleteIdCodeReq, EditIdCodeReq, IdCode } from "../../type/idcode";

export class IdCodeAdapter {
  static toEditInputDTO(req: EditIdCodeReq): any {
    return req.map((e) => {
      const groups: any[] = Array.isArray(e.group) ? e.group : [e.group];
      const trueGroup = groups.find((g) => g.value === true);
      return {
        category_id: trueGroup ? trueGroup.id.toString() : null,
        user_code: e.id_code,
      };
    });
  }

  static toDeleteInputDTO(req: DeleteIdCodeReq): any {
    return {
      user_code: req.id_code,
    };
  }

  static toOutputDTO(res: any): IdCode[] {
    const groups = res.subject_group;
    return res.service
      ? res.service.map((e: any) => ({
          id: e.id,
          id_code: e.id_code,
          status: e.is_code_status,
          integration_code: e.youd_user_id ?? null,
          group:
            groups.map((group: any) => ({
              id: group.id,
              key: group.name,
              value: group.id === e.subject_group.id,
            })) || [],
          desc: e.memo ?? null,
        }))
      : [];
  }
}
